/**
 * Logic to close elements marked with is-dismissable
 */

export default class Dismissable {

  constructor(el) {

    this.el = el;
    this.isLanguageSelector = this.el.classList.contains('alert-language');
    this.dismissEl = this.el.querySelector('.button-dismiss');
    this.dismissId = this.el.getAttribute('data-dismiss-id');
    this.cookieDomain = (window.app || {}).cookieDomain || window.location.hostname.replace(/^www./, '');
    if (this.dismissEl) {

      this.dismissEl.addEventListener('click', this.dismiss.bind(this));
    }
    if (this.isLanguageSelector) {

      const a = this.el.querySelector('a[href="#"]');
      if (a) {

        a.addEventListener('click', this.onClick.bind(this));
      }
    }
  }

  onClick(e) {

    const targetLanguage = this.el.getAttribute('data-target-language');
    if (targetLanguage) {

      const targetUrl = window.langUrls[targetLanguage];
      this.setLangCookie(targetLanguage);
      document.location.href = targetUrl;
    } else {

      this.dismiss();
    }
    e.preventDefault();
  }

  dismiss(e) {

    this.el.classList.add('is-dismissed');
    if (this.dismissId) {

      document.cookie = `${this.dismissId}=dismissed; path=/; domain=${this.cookieDomain}`;
    }
    if (this.isLanguageSelector) {

      this.setLangCookie(document.documentElement.lang);
    }
    e.preventDefault();
  }

  setLangCookie(language) {

    const expires = new Date();
    expires.setTime(expires.getTime() + 1000 * 315360000);
    document.cookie = 'preferredLanguage=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    if ( window.consent === undefined || window.consent.hasConsented.indexOf('required') >= 0) {

      document.cookie = `preferredLanguage=${language};path=/;domain=${this.cookieDomain};expires=${expires.toUTCString()}`;
    }
  }
}
